import React, { useEffect, useState } from "react";
import { LegalDocumentPage } from "@/components/LegalDocumentPage";
import api from "@/lib/api";
import { LEGAL_OPERATOR, PRIVACY_SECTIONS } from "@/content/legalHu";
import { interpolateLegalSections } from "@/lib/legalInterpolate";

export default function Privacy() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/legal-pages")
      .then((r) => setData(r.data))
      .catch(() =>
        setData({
          operator: LEGAL_OPERATOR,
          privacy: {
            title: "Adatvédelmi tájékoztató",
            sections: interpolateLegalSections(PRIVACY_SECTIONS, LEGAL_OPERATOR),
          },
        }),
      )
      .finally(() => setLoading(false));
  }, []);

  return (
    <LegalDocumentPage
      testId="privacy-page"
      loading={loading}
      title={data?.privacy?.title || "Adatvédelmi tájékoztató"}
      description="AutoPark adatkezelési tájékoztató."
      sections={data?.privacy?.sections}
      operator={data?.operator}
    />
  );
}
